export enum EAccountType {
    BUYER_PORTAL = 'buyer',
    SUPPLIER_PORTAL = 'supplier',
    MARIHUB_PORTAL = 'marihub'
}
